import {Y} from '@juicemind/visual-collab';
import {ScratchBridge} from '@juicemind/visual-collab/bridge/scratch';
import {attachEditorRelay, onCollabStart} from '@juicemind/visual-collab/iframe-relay/editor';
import {attachScratchPresence} from '@juicemind/visual-collab/presence/scratch';

import relay from './jm-host-relay.js';
import {setReadOnly} from './jm-read-only.js';

let session = null;

const publishCollab = value => {
    window.__JM_COLLAB__ = value;
    window.dispatchEvent(new CustomEvent('jm:collab'));
};

export const stopCollab = () => {
    if (!session) return;
    const current = session;
    session = null;
    publishCollab(null);
    setReadOnly(false);
    current.presence.destroy();
    current.bridge.stop();
    current.relay.destroy();
    current.doc.destroy();
};

export const isCollabActive = () => session !== null;

const SETTLE_POLL_MS = 250;

export const whenCollabSettled = maxMs => new Promise(resolve => {
    const startedAt = Date.now();
    const check = () => {
        if (!session || session.bridge.isSettled() || Date.now() - startedAt >= maxMs) {
            resolve();
            return;
        }
        setTimeout(check, SETTLE_POLL_MS);
    };
    check();
});

export const installCollab = () => {
    onCollabStart((message, hostWindow, hostOrigin) => {
        stopCollab();
        const vm = window.vm;
        if (!vm) {
            hostWindow.postMessage({
                type: 'COLLAB_ERROR',
                instanceId: message.instanceId,
                message: 'VM not ready'
            }, hostOrigin);
            return;
        }
        const doc = new Y.Doc();
        const editorRelay = attachEditorRelay({doc, start: message, hostWindow, hostOrigin, onStop: stopCollab});
        const bridge = new ScratchBridge(vm, doc, {
            onError: (error, context) => editorRelay.reportError(`${context}: ${error.message}`),
            getAsset: editorRelay.assets.get,
            putAsset: editorRelay.assets.put
        });
        if (message.readOnly) {
            bridge.loadReadOnly(true);
        } else {
            bridge.start();
        }
        setReadOnly(!!message.readOnly);
        const presence = attachScratchPresence({relay: editorRelay, vm});
        session = {doc, bridge, relay: editorRelay, presence};
        publishCollab({awareness: editorRelay.awareness, currentUserId: (message.user && message.user.id) || null});
    }, event => relay.accept(event));

    window.scratchCollabActive = isCollabActive;
};
